import { render, staticRenderFns } from "./BankEdit.vue?vue&type=template&id=6c7621f8&"
import script from "./BankEdit.vue?vue&type=script&lang=js&"
export * from "./BankEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports